/**
 * Recharge Widget Generator
 * Creates custom subscription UI and handles subscription/one-time toggle
 */

const checkIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
  <mask id="mask0_2001_334" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="19" height="19">
    <rect x="0.25" y="0.5" width="18" height="18" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_2001_334)">
    <path d="M7.4127 13.9997L3.1377 9.72471L4.20645 8.65596L7.4127 11.8622L14.2939 4.98096L15.3627 6.04971L7.4127 13.9997Z" fill="#1C1B1F"/>
  </g>
</svg>
`;

function generateRechargeWidgetHtml() {
  // Check if custom widget already exists
  const existingCustomWidget = document.querySelector('.subscription-widget');
  if (existingCustomWidget) {
    return; // Already generated, don't regenerate
  }

  // Validate that the widget is loaded
  const rechargeWidget = document.querySelector('.recharge-subscription-widget label.subscription-radio');
  if (!rechargeWidget) {
    return;
  }

  const appBlockContainer = document.querySelector('.shopify-block.shopify-app-block.recharge-subscription-widget');
  if (!appBlockContainer) {
    return; // App block container doesn't exist
  }
  
  const quickAddButton = document.querySelector('.main-product .product-form__submit');
  
  // Get discount label with safety check
  const discountLabelElement = appBlockContainer.querySelector('label.subscription-radio .discount-label');
  const rechargeWidget_discountLabel = discountLabelElement ? discountLabelElement.textContent.replace(/\d+%/g, '').trim() : 'Subscribe & Save';
  
  // Get checked state with safety check
  const subscriptionInputElement = appBlockContainer.querySelector('label.subscription-radio > input');
  const rechargeWidget_discountChecked = subscriptionInputElement ? subscriptionInputElement.checked : false;
  
  // Get price label with safety check
  const priceLabelElement = appBlockContainer.querySelector('label.subscription-radio .price-label');
  const rechargeWidget_priceLabel = priceLabelElement ? priceLabelElement.textContent.replace('$', '') : '0.00';
  
  // Get compare at price element with safety check
  const compareAtPriceElement = document.querySelector('.product__info-media-description-right .product-price');
  const rechargeWidget_compareAtPriceElement = compareAtPriceElement ? compareAtPriceElement.outerHTML : '<div class="product-price">$0.00</div>';

  const mainPerk = document.getElementById('subscribe-and-save-main-perk');
  let mainPerkHtml = '';
  if (mainPerk) {
    mainPerkHtml = mainPerk.innerHTML;
  }

  // Get selling plans with safety check
  const sellingPlansSelect = appBlockContainer.querySelector('.rc-selling-plans select');
  const rechargeWidget_plans = (rechargeWidget_discountChecked && sellingPlansSelect) ? Array.from(sellingPlansSelect.options) : [];

  // Get current variant availability
  // Use window.getCurrentVariant if available, otherwise try to get variant directly
  let currentVariant = null;
  if (typeof window.getCurrentVariant === 'function') {
    currentVariant = window.getCurrentVariant();
  } else {
    // Fallback: Get variant from product form
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) {
      const variantSelectsContainer = document.querySelector('variant-selects');
      if (variantSelectsContainer) {
        const sectionId = variantSelectsContainer.dataset.section;
        const productJsonElement = document.getElementById(`ProductJson-${sectionId}`);
        if (productJsonElement) {
          const productData = JSON.parse(productJsonElement.textContent);
          if (productData && productData.variants) {
            currentVariant = productData.variants.find(v => v.id.toString() === variantInput.value);
          }
        }
      }
    }
  }
  
  // Generate one-time purchase price HTML with discount support
  let oneTimePriceHtml = '';
  if (currentVariant) {
    const priceParts = (currentVariant.price / 100).toFixed(2).split('.');
    const compareAtPriceParts = currentVariant.compare_at_price ? (currentVariant.compare_at_price / 100).toFixed(2).split('.') : null;
    
    if (currentVariant.compare_at_price > currentVariant.price) {
      // Show both discounted price and compare_at_price (strikethrough)
      oneTimePriceHtml = `
      <div class="product-price">
        <span class="currency">$</span>
        <span class="dollars">${priceParts[0]}</span>
        <span>.</span>
        <span class="cents">${priceParts[1]}</span>
      </div>
      <span class="compare-at-price">
        <div class="product-price">
          <span class="currency">$</span>
          <span class="dollars">${compareAtPriceParts[0]}</span>
          <span class="cents">${compareAtPriceParts[1]}</span>
        </div>
      </span>
    `;
    } else {
      // No discount, show regular price only
      oneTimePriceHtml = `
      <div class="product-price">
        <span class="currency">$</span>
        <span class="dollars">${priceParts[0]}</span>
        <span>.</span>
        <span class="cents">${priceParts[1]}</span>
      </div>
    `;
    }
  } else {
    // Fallback to compareAtPriceElement if variant not available
    oneTimePriceHtml = rechargeWidget_compareAtPriceElement;
  }
  
  const isAvailable = currentVariant && currentVariant.available;
  const buttonText = isAvailable ? 'Add to Cart' : 'Out of Stock';
  const subscribeButtonText = isAvailable ? 'Subscribe' : 'Out of Stock';
  const buttonOpacity = isAvailable ? '1' : '0.5';
  const buttonCursor = isAvailable ? 'pointer' : 'not-allowed';

  if (quickAddButton) {
    quickAddButton.disabled = !isAvailable;
    quickAddButton.textContent = isAvailable ? 'Add to Cart' : 'Out of Stock';
    quickAddButton.style.opacity = isAvailable ? '1' : '0.5';
    quickAddButton.style.cursor = isAvailable ? 'pointer' : 'not-allowed';
  }

  // Get icon-caret with safety check
  const iconCaretElement = document.getElementById('icon-caret');
  const iconCaret = iconCaretElement ? iconCaretElement.innerHTML : '<svg><!-- fallback caret --></svg>';

  const subscribeAndSavePerks = document.getElementById('subscribe-and-save-perks');
  let perksHtml = '';

  if (subscribeAndSavePerks) {
    const perks = Array.from(subscribeAndSavePerks.querySelectorAll('.subscribe-and-save-perk'));
    perksHtml = perks.map(perk => `<div class="subscribe-and-save-perks__item">
      <span class="subscribe-and-save-perks__item-icon">${checkIcon}</span>
      <span class="subscribe-and-save-perks__item-text">${perk.textContent}</span>
    </div>`).join('');
  }

  let html = `
    <div class="subscription-widget" data-subscribe="${rechargeWidget_discountChecked ? 'true' : 'false'}">
      ${mainPerkHtml}
      <div class="subscribe-and-save-container subscribe-and-save">
        <div class="subscribe-and-save-container__title">
          <label class="subscribe-and-save-container__radio" for="subscribe-and-save-container__radio-subscribe">
            <input type="radio" name="subscription-toggle" id="subscribe-and-save-container__radio-subscribe" class="subscribe-and-save-container__radio" ${rechargeWidget_discountChecked ? 'checked' : ''}>
            ${rechargeWidget_discountLabel}
          </label>

          <div class="subscribe-and-save-savings">
            <div class="product-price">
              <span class="currency">$</span>
              <span class="dollars">${rechargeWidget_priceLabel.split('.')[0]}</span>
              <span>.</span>
              <span class="cents">${rechargeWidget_priceLabel.split('.')[1]}</span>
            </div>
            <span class="compare-at-price">
              ${rechargeWidget_compareAtPriceElement}
            </span>
          </div>
        </div>
        <div class="subscribe-and-save-content-container">
          <div style="display: flex; flex-direction: column; min-height: fit-content;padding-top: 20px;">
            <div class="subscribe-and-save-perks">
              ${perksHtml}
            </div>
            <div class="subscribe-and-save-plan">
              <div class="select">
                <select class="subscribe-and-save-plan__select">
                  ${rechargeWidget_plans.map(plan => `<option value="${plan.value}">${plan.text}</option>`).join('')}
                </select>
                ${iconCaret}
              </div>
              <div class="subscription-terms">
                <button type="button" class="subscription-terms-trigger" aria-label="View subscription terms">
                  <span>Subscription Terms</span>
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 0.5C2.96243 0.5 0.5 2.96243 0.5 6C0.5 9.03757 2.96243 11.5 6 11.5C9.03757 11.5 11.5 9.03757 11.5 6C11.5 2.96243 9.03757 0.5 6 0.5ZM6.75 8.75H5.25V5.25H6.75V8.75ZM6.75 4.25H5.25V2.75H6.75V4.25Z" fill="currentColor"/>
                  </svg>
                </button>
                <div class="subscription-terms-tooltip">
                  <div class="subscription-terms-content">
                    <p>You may skip, pause, or cancel anytime through your account or via email at support@volcanicacoffee.com. You will be automatically charged the above amount at the frequency you select until you cancel.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <button type="button" class="subscribe-and-save-button" ${!isAvailable ? 'disabled' : ''} style="opacity: ${buttonOpacity}; cursor: ${buttonCursor};">
              ${subscribeButtonText}
            </button>
          </div>
        </div>
      </div>

      <div class="subscribe-and-save-container one-time-purchase">
        <div class="subscribe-and-save-container__title">
          <label class="subscribe-and-save-container__radio" for="subscribe-and-save-container__radio-one-time">
            <input type="radio" name="subscription-toggle" id="subscribe-and-save-container__radio-one-time" class="subscribe-and-save-container__radio" ${rechargeWidget_discountChecked ? '' : 'checked'}>
            One-Time Purchase
          </label>

          <div class="subscribe-and-save-savings">
            ${oneTimePriceHtml}
          </div>
        </div>
        <div class="subscribe-and-save-content-container">
          <div style="display: flex; flex-direction: column; min-height: fit-content;padding-top: 20px;">
            <button type="button" class="subscribe-and-save-button" ${!isAvailable ? 'disabled' : ''} style="opacity: ${buttonOpacity}; cursor: ${buttonCursor};">
              ${buttonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  `;

  appBlockContainer.insertAdjacentHTML('beforeend', html);

  const subscriptionWidget = appBlockContainer.querySelector('#subscribe-and-save-container__radio-subscribe');
  const oneTimeWidget = appBlockContainer.querySelector('#subscribe-and-save-container__radio-one-time');
  
  if (subscriptionWidget) {
    subscriptionWidget.addEventListener('change', () => {
      handleSubscriptionToggle(true);
    });
  }
  
  if (oneTimeWidget) {
    oneTimeWidget.addEventListener('change', () => {
      handleSubscriptionToggle(false);
    });
  }

  // Add subscription terms tooltip functionality
  const subscriptionTermsTrigger = appBlockContainer.querySelector('.subscription-terms-trigger');
  const subscriptionTermsTooltip = appBlockContainer.querySelector('.subscription-terms-tooltip');
  
  if (subscriptionTermsTrigger && subscriptionTermsTooltip) {
    subscriptionTermsTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      subscriptionTermsTooltip.classList.toggle('show');
    });

    document.addEventListener('click', (e) => {
      if (!subscriptionTermsTrigger.contains(e.target) && !subscriptionTermsTooltip.contains(e.target)) {
        subscriptionTermsTooltip.classList.remove('show');
      }
    });

    subscriptionTermsTrigger.addEventListener('mouseenter', () => {
      subscriptionTermsTooltip.classList.add('show');
    });

    subscriptionTermsTrigger.addEventListener('mouseleave', () => {
      setTimeout(() => {
        if (!subscriptionTermsTooltip.matches(':hover')) {
          subscriptionTermsTooltip.classList.remove('show');
        }
      }, 100);
    });

    subscriptionTermsTooltip.addEventListener('mouseleave', () => {
      subscriptionTermsTooltip.classList.remove('show');
    });
  }
}

function handleSubscriptionToggle(checked) {
  const appBlockContainer = document.querySelector('.shopify-block.shopify-app-block.recharge-subscription-widget');
  const subscriptionWidget = appBlockContainer.querySelector('.subscription-widget');
  const oneTimeToggle = appBlockContainer.querySelector('.rc-button-group__options .onetime-radio');
  const subscriptionToggle = appBlockContainer.querySelector('.rc-button-group__options .subscription-radio');
  
  if (subscriptionWidget) {
    subscriptionWidget.dataset.subscribe = checked;
    if (checked) {
      subscriptionToggle?.click();
    } else {
      oneTimeToggle?.click();
    }
  }
}

